import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { ProdConfig } from './blocks/config/prod.config';
import { JYoguiAppModule } from './app.module';

ProdConfig();

if (module['hot']) {
    module['hot'].accept();
}

platformBrowserDynamic().bootstrapModule(JYoguiAppModule)
                        .then(() => {
                            const loader = document.getElementById('loader');
                            if (loader) {
                            loader.style.display = 'none';
                            }
                        })
                        .catch(err => console.error(err));



// WEBPACK FOOTER //
// ./src/main/webapp/app/app.main.ts